export default "__VITE_ASSET__8e8f4cb9__"